module.exports = __webpack_public_path__ + "aaf2083adca0ff3ffc25abb399be3b05.MP3";